import { vueAuth } from "../services/auth";
import { $routerRef } from "..";
import { usersApi } from "@/services/api/user.api";
import { appTitle } from "@/constants";
import SessionExpiredService from "../../../services/appSessionExpired.service";
import appSnackbarService from "../../../services/appSnackbar.service";
import i18n from "../../../services/i18n";

export default {
  state: {
    currentUser: null,
    error: "",
    loading: false
  },
  mutations: {
    AUTHENTICATION_ERROR(state: any, payload: any) {
      state.error = payload;
    },
    SET_AUTHENTICATED(state: any, payload: any) {
      state.error = "";
    },
    SET_CURRENTUSER(state: any, payload: any) {
      state.error = "";
      state.currentUser = payload.user;
      state.currentRoles = payload.roles;
    },

    LOGIN_STARTED(state: any) {
      state.loading = true;
    },

    LOGIN_FINISHED(state: any) {
      state.loading = false;
    }
  },
  actions: {
    login(context: any, payload: any) {
      context.commit("LOGIN_STARTED");
      vueAuth
        .login(payload.user)
        .then(response => {
          context.commit("SET_AUTHENTICATED");
          const data = response.data;
          const usrObj = { usr: data.userId, unit: appTitle };
          localStorage.setItem("qlm-user", JSON.stringify(usrObj));

          if (data.mustChangePassword || data.passwordExpired) {
            sessionStorage.setItem("qlm-pwd-required", "1");
            $routerRef.replace({ name: "requiredPasswordChange" });
            return;
          }

          sessionStorage.removeItem("qlm-pwd-required");
          if (data.passwordExpiryWarningDays != null) {
            appSnackbarService.warning(
              String(
                i18n.t("LOGIN_PASSWORD_EXPIRY_WARNING", {
                  days: data.passwordExpiryWarningDays
                })
              ),
              8000
            );
          }

          $routerRef.replace("/");
        })
        .catch((error: any) => {
          context.commit("AUTHENTICATION_ERROR", error.response.data);
        })
        .finally(() => {
          context.commit("LOGIN_FINISHED");
        });
    },

    logout(context: any, payload: any) {
      // console.log("auth module: logout");
      SessionExpiredService.hide();

      sessionStorage.removeItem("qlm-pwd-required");

      // Clear local state immediately
      localStorage.removeItem("qlm-user");
      context.commit("SET_CURRENTUSER", {
        user: undefined,
        roles: undefined
      });

      // Try to call the logout endpoint, but don't fail if token is expired
      vueAuth.logout().then(() => {
        console.log("auth module: logged out successfully");
        $routerRef.replace("login");
      }).catch((err) => {
        console.log("auth module: logout endpoint failed (token likely expired), redirecting anyway");
        // Even if logout endpoint fails, redirect to login
        $routerRef.replace("login");
      });
    },

    checkTokenExpiration(context: any) {
      // Check if token is expired and logout if needed
      // console.log("checkTokenExpiration");
      if (!vueAuth.isAuthenticated()) {
        console.log("logging out....");
        context.dispatch("logout");
        return;
      }

      // Get token from localStorage or vueAuth
      const token = vueAuth.getToken();
      if (token) {


        try {
          // Decode JWT token to check expiration
          const payload = JSON.parse(atob(token.split(".")[1]));
          const expirationTime = payload.exp * 1000; // Convert to milliseconds
          const currentTime = Date.now();
          const timeUntilExpiration = expirationTime - currentTime;
          // console.log("timeUntilExpiration: ", timeUntilExpiration);

          // If token is already expired, logout immediately
          if (timeUntilExpiration <= 0) {
            context.dispatch("logout");
            return;
          }

          // If token expires in next 5 minutes, show warning
          if (timeUntilExpiration < 5 * 60 * 1000 && timeUntilExpiration > 0) {
            // Check if we haven't already shown the warning for this token
            const lastWarningTime = localStorage.getItem("token-warning-shown");
            const tokenId = payload.jti || payload.sub;

            // // console.log("lastWarningTime: ", lastWarningTime);

            if (!lastWarningTime || lastWarningTime !== tokenId) {
              // Show warning popup
              console.log("run showSessionExpiryWarning ");
              // const timeRemaining = Math.floor(timeUntilExpiration / 1000 / 60);
              // SessionExpiredService.show(timeRemaining);

              context.dispatch("showSessionExpiryWarning", {
                timeRemaining: Math.floor(timeUntilExpiration / 1000 / 60), // minutes
                tokenId
              });
            }
          }
        } catch (error) {
          // If token is malformed, logout
          context.dispatch("logout");
        }
      }
    },

    showSessionExpiryWarning(context: any, payload: any) {
      // Store that we've shown the warning for this token
      localStorage.setItem("token-warning-shown", payload.tokenId);

      // Use the service to show the dialog
      SessionExpiredService.show(payload.timeRemaining);
    },

    getCurrentUser(context: any, payload: any) {
      usersApi
        .getCurrentUser()
        .then((response: any) => {
          context.commit("SET_CURRENTUSER", response.data);
        })
        .catch(() => {
          // -
        });
    }
  },
  getters: {
    isAuthenticated() {
      return vueAuth.isAuthenticated();
    },
    currentUser(state) {
      return state.currentUser;
    },
    currentRoles(state) {
      return state.currentRoles;
    }
  }
};
